if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
          item.querySelector('button')?.addEventListener(
            'click',
            this.setActiveMedia.bind(this, item.dataset.target, false)
          );
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((item) => {
          item.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          const thumbnail = this.elements.thumbnails?.querySelector(
            `[data-target="${mediaId}"]`
          );
          if (thumbnail && thumbnail.parentElement.firstElementChild !== thumbnail) {
            thumbnail.parentElement.prepend(thumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!activeMedia.isConnected) return;

          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;

          window.scrollTo({
            top: rect.top + window.scrollY,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${mediaId}"]`
        );
        if (!thumbnail) return;

        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(activeMedia, thumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
          button.removeAttribute('aria-current');
        });
        thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');

        if (this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) return;

        this.elements.thumbnails.slider?.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}

(() => {
  const supportedColours = [
    'blue', 'black', 'white', 'purple', 'pink', 'stone', 'green'
  ];

  function setupGallery(gallery) {
    if (gallery.dataset.hbGalleryReady) return;

    const productInfo = gallery.closest('product-info');
    if (!productInfo) return;

    const imageDetails = (item) => {
      const image = item.querySelector('img');
      if (!image) return '';
      return [
        image.getAttribute('src'),
        image.getAttribute('srcset'),
        image.getAttribute('alt'),
      ].filter(Boolean).join(' ').toLowerCase();
    };

    if (
      !Array.from(gallery.querySelectorAll('.product__media-item'))
        .some((item) => imageDetails(item).includes('fairway-cap-'))
    ) return;



    function getSelectedColour() {
      const options = productInfo.querySelectorAll(
        'variant-radios input:checked, variant-selects input:checked, ' +
        'variant-selects select'
      );

      for (const option of options) {
        const colour = option.value.toLowerCase().trim();
        if (supportedColours.includes(colour)) return colour;
      }
      return null;
    }

    function visibleThumbnails() {
      return Array.from(gallery.querySelectorAll('.thumbnail-list__item'))
        .filter((item) => item.style.display !== 'none')
        .map((item) => item.querySelector('button'))
        .filter(Boolean);
    }

    function updateGallery() {
      const colour = getSelectedColour();
      if (!colour) return;

      const matches = (item) =>
        imageDetails(item).includes(`fairway-cap-${colour}-`);

      const mainImages = Array.from(
        gallery.querySelectorAll('.product__media-item')
      );

      if (!mainImages.some(matches)) return;

      mainImages.forEach((item) => {
        item.style.display = matches(item) ? '' : 'none';
      });

      gallery.querySelectorAll('.thumbnail-list__item').forEach((item) => {
        item.style.display = matches(item) ? '' : 'none';
      });

      gallery.querySelectorAll('slider-component').forEach((slider) => {
        slider.resetPages?.();
      });

      const firstThumbnail = visibleThumbnails()[0];
      if (firstThumbnail) {
        firstThumbnail.click();
      } else {
        const firstImage = mainImages.find(matches);
        gallery.setActiveMedia?.(firstImage.dataset.mediaId, false);
      }
    }

    function changeImage(direction) {
      const thumbnails = visibleThumbnails();
      if (thumbnails.length < 2) return;

      let current = thumbnails.findIndex(
        (button) => button.getAttribute('aria-current') === 'true'
      );
      if (current < 0) current = 0;

      thumbnails[
        (current + direction + thumbnails.length) % thumbnails.length
      ].click();
    }

    gallery.addEventListener('click', (event) => {
      const button = event.target.closest(
        'slider-component:not(.thumbnail-slider) .slider-button'
      );
      if (!button || !gallery.contains(button)) return;

      let direction;
      if (button.classList.contains('slider-button--prev')) direction = -1;
      if (button.classList.contains('slider-button--next')) direction = 1;
      if (!direction) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      changeImage(direction);
    }, true);
const galleryObserver = new MutationObserver((changes) => {
  const imagesAdded = changes.some((change) =>
    Array.from(change.addedNodes).some((node) =>
      node.nodeType === 1 &&
      (
        node.matches('.product__media-item, .thumbnail-list__item') ||
        node.querySelector('.product__media-item, .thumbnail-list__item')
      )
    )
  );

  if (imagesAdded) updateGallery();
});

galleryObserver.observe(gallery, {
  childList: true,
  subtree: true,
});
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!gallery.isConnected) return;

      const sectionId =
        productInfo.dataset.originalSection || productInfo.dataset.section;

      if (String(data.sectionId) === String(sectionId)) {
        updateGallery();
      }
    });

    updateGallery();
    gallery.dataset.hbGalleryReady = 'true';
  }

  function setupGalleries() {
    document.querySelectorAll('media-gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGalleries);
  } else {
    setupGalleries();
  }

  document.addEventListener('shopify:section:load', setupGalleries);
  document.addEventListener('product-info:loaded', setupGalleries);
})();